<template>
  <v-container>
    <v-layout text-xs-center wrap class="justify-center" v-if="product">
      <v-flex mb-2 xs12>
        <v-btn :to="`/events/${event_id}/product_category/${product.category}`">
          다른 상품 View Similar Products
        </v-btn>
      </v-flex>
      <v-flex mb-2 xs12>
        <b style="font-size: 1.5em">
          {{ product.name }}
        </b>
      </v-flex>

      <v-flex mb-2 xs12>
        {{ product.description }}
      </v-flex>
      <v-flex mb-2 xs12 text-xs-left>
        <b>Price:</b> {{ product.currency }}
        {{ product.price.toLocaleString() }}
      </v-flex>
      <v-flex mb-2 xs12 text-xs-left>
        <b>상품 오펜Opens At:</b> {{ product.start_at_text }}
      </v-flex>
      <v-flex mb-2 xs12 text-xs-left>
        <b>입금마감 Pay By:</b> {{ product.pay_by_text }}
      </v-flex>
      <v-flex mb-2 xs12 text-xs-left>
        <span v-html="product.details"></span>
      </v-flex>

      <v-flex
        mb-2
        xs12
        text-xs-left
        v-if="!event.mytaptags_preactive_options && product.immediate_sale"
      >
        <b>구매 제한 조건 / Special Conditions</b>
        <ul>
          <li>
            This item may not be purchased with any other passes, tickets or
            add-on items. Additional items may be purchased on an individual
            basis after this order is confirmed.
          </li>
          <li>
            본 상품을 구매한 경우 다른 티켓 상품(개인 티켓 혹은 그룹 티켓 등)을
            구매할 수 없습니다.
          </li>
          <li>
            본 상품은 추가상품(조식, 셔틀버스)와 동시에 결제 할 수 없습니다.
          </li>
          <li>
            추가 상품은 그룹 등록이 완료된 후 개별적으로 구매하시기 바랍니다.
          </li>
        </ul>
      </v-flex>
      <v-flex mb-2 xs12 v-for="sc in valid_sales_channels" :key="sc.id">
        <v-btn
          :to="
            `/events/${event_id}/products/${product.id}/sale_${sc.code}/${sc.id}`
          "
          color="info"
          >구매하기({{ sc.description }})</v-btn
        >
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {mapState} from 'vuex';

export default {
  data: () => ({event_id: undefined}),
  beforeMount: async function() {
    this.$store.dispatch('loadEvents');
    this.$store.dispatch('loadEventSalesChannels', {
      event_id: this.$route.params.event_id,
    });
    this.$store.dispatch('loadEventProducts', {
      event_id: this.$route.params.event_id,
    });
    this.$store.dispatch('loadAttendees');
    this.$data.event_id = this.$route.params.event_id;
  },
  computed: {
    ...mapState([
      'myprofile',
      'events',
      'event_products',
      'attendees',
      'event_sales_channels',
    ]),
    event: function() {
      return this.events?.find(x => {
        return x.id == this.$route.params.event_id;
      });
    },
    product() {
      return (this.$data.product = this.event_products?.find(x => {
        return x.id == this.$route.params.product_id;
      }));
    },
    valid_sales_channels() {
      return this.event_sales_channels?.filter(esc => {
        return this.product.sales_channel_ids.includes(esc.id);
      });
    },
  },
  methods: {},
};
</script>

<style></style>
